import { Cidade, Clientes, ClientesAttributes, ClientesSearchBox, ContatoCliente, error99, Estado, RetAPI, Usuarios } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { encode as base64_encode } from 'base-64'
import { v4 as uuid } from 'uuid'

export const ClientesService = {

    // sem uso
    /*
    FilterRelatorio: async (filterCliente?: any): Promise<Clientes[]> => {

        const resp = await Api('Cliente/Report/Filter', 'get', {

            datai: filterCliente.datai,
            dataf: filterCliente.dataf,
            ativo: filterCliente.ativo,
            id_cidade: filterCliente.id_cidade,
            uf: filterCliente.uf,
            fisica_juridica: filterCliente.fisica_juridica

        })
        const cliente: Clientes[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '0') {
                resp.data.clientes.map((item: any) => {
                    return cliente.push({

                        id: item.id,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        tipo_pessoa: item.tipo_pessoa,
                        cnpj_cpf: item.cnpj_cpf,
                        nome: item.nome,
                        nome_fantasia: item.nome_fantasia,
                        ie_rg: item.ie_rg,
                        ativo: item.ativo,
                        observacao: item.observacao,
                        cep: item.cep,
                        endereco: item.endereco,
                        bairro: item.bairro,
                        numero: item.numero,
                        complemento: item.complemento,
                        uf: item.uf,
                        id_cidade: item.id_cidade,
                        nome_cidade: item.nome_cidade,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dt_nascimento: item.dt_nascimento,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        description: item.nome,
                    })
                })

                return cliente
            } else {
                return []
            }
        } else {
            return []
        }
    },

    //let clientesArray
        
        if (typeof resp.data.clientes === 'object' && !Array.isArray(resp.data.clientes)) {

                clientesArray = [resp.data.clientes]

            } else {

                clientesArray = resp.data.clientes
        }
        
    */

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Cliente/Attributes', 'get', { id })
        const attributes: ClientesAttributes = {
            estados: [],
            cidades: [],
            usuarios: [],
            cliente: {
                id: 0,
                id_cidade: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                dt_cadastro: '',
                dt_last_update: '',
                dt_nascimento: '',
                nome: '',
                endereco: '',
                bairro: '',
                numero: 0,
                cep: '',
                uf: '',
                tipo_pessoa: '',
                cnpj_cpf: '',
                ie_rg: '',
                complemento: '',
                observacao: '',
                ativo: '',
                nome_fantasia: '',
                nome_cidade: '',
                name_user_insert: '',
                name_user_last_update: '',
                description: ''
            }
        }

        if (resp.data) {

            let estados: Estado[] = []
            let cidades: Cidade[] = []
            let usuarios: Usuarios[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.estados) {
                    estados = resp.data.estados.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome,
                            sigla: item.sigla,
                            codIBGE: item.codIBGE,
                        }
                    })
                    attributes.estados = estados
                }

                if (resp.data.cidades) {
                    cidades = resp.data.cidades.map((item: any) => {
                        return {
                            id: item.codigo,
                            description: item.nome,
                            uf: item.uf,
                            codIBGE: item.codigo,
                        }
                    })
                    attributes.cidades = cidades
                }

                if (resp.data.usuarios) {
                    resp.data.usuarios.map((item: any) => attributes.usuarios.push(
                        {
                            id: item.id,
                            nome: item.nome,
                            email: '',
                            password: '',
                            ativo: true,
                            id_empresa: 0,
                            description: item.nome
                        }
                    ))
                    attributes.usuarios = usuarios
                }

                if (resp.data.cliente) {

                    attributes.cliente.id = resp.data.cliente.id
                    attributes.cliente.id_cidade = resp.data.cliente.id_cidade
                    attributes.cliente.id_user_insert = resp.data.cliente.id_user_insert
                    attributes.cliente.id_user_last_update = resp.data.cliente.id_user_last_update
                    attributes.cliente.id_user_exclusao = resp.data.cliente.id_user_exclusao
                    attributes.cliente.dt_cadastro = resp.data.cliente.dt_cadastro
                    attributes.cliente.dt_last_update = resp.data.cliente.dt_last_update
                    attributes.cliente.dt_nascimento = resp.data.cliente.dt_nascimento
                    attributes.cliente.nome = resp.data.cliente.nome
                    attributes.cliente.endereco = resp.data.cliente.endereco
                    attributes.cliente.bairro = resp.data.cliente.bairro
                    attributes.cliente.numero = resp.data.cliente.numero
                    attributes.cliente.cep = resp.data.cliente.cep
                    attributes.cliente.uf = resp.data.cliente.uf
                    attributes.cliente.tipo_pessoa = resp.data.cliente.tipo_pessoa
                    attributes.cliente.cnpj_cpf = resp.data.cliente.cnpj_cpf
                    attributes.cliente.ie_rg = resp.data.cliente.ie_rg
                    attributes.cliente.complemento = resp.data.cliente.complemento
                    attributes.cliente.observacao = resp.data.cliente.observacao
                    attributes.cliente.ativo = resp.data.cliente.ativo
                    attributes.cliente.nome_fantasia = resp.data.cliente.nome_fantasia
                    attributes.cliente.nome_cidade = resp.data.cliente.nome_cidade
                    attributes.cliente.name_user_insert = resp.data.cliente.name_user_insert
                    attributes.cliente.name_user_last_update = resp.data.cliente.name_user_last_update
                    attributes.cliente.description = resp.data.cliente.nome

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }
    },

    Save: async (cliente: any): Promise<RetAPI> => {

        let id = ''

        if (cliente.id) {
            id = cliente.id.toString()
        }

        const resp = await Api('Cliente/Save', 'post', {

            nome: cliente.nome,
            nome_fantasia: cliente.nome_fantasia,
            endereco: cliente.endereco,
            bairro: cliente.bairro,
            numero: cliente.numero,
            cep: cliente.cep,
            id_cidade: cliente.id_cidade,
            uf: cliente.uf,
            tipo_pessoa: cliente.tipo_pessoa,
            cnpj_cpf: cliente.cnpj_cpf,
            ie_rg: cliente.ie_rg,
            complemento: cliente.complemento,
            observacao: cliente.observacao,
            ativo: cliente.ativo,
            dt_nascimento: cliente.dt_nascimento,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados do cliente gravados com sucesso',
                id: resp.data.cliente.id,
                data: resp.data,
                dt_cadastro: resp.data.cliente.dt_cadastro,
                dt_last_update: resp.data.cliente.dt_last_update,
                name_user_insert: resp.data.cliente.name_user_insert,
                name_user_last_update: resp.data.cliente.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Cliente/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {

            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, filterCliente?: any, id?: string): Promise<RetAPI> => {

        const resp = await Api('Cliente/Filter', 'get', {
            field,
            filter_type,
            filter,
            id,
            dt_cad_ini: filterCliente?.dt_cad_ini,
            dt_cad_fim: filterCliente?.dt_cad_fim,
            tipo_pessoa: filterCliente?.tipo_pessoa,
            status: filterCliente?.status,
            uf: filterCliente?.uf,
            id_cidade: filterCliente?.id_cidade,
        })
        const cliente: Clientes[] = []

        let clientesArray;

        if (resp.data) {

            if (typeof resp.data.clientes === 'object' && !Array.isArray(resp.data.clientes)) {

                clientesArray = [resp.data.clientes]

            } else {

                clientesArray = resp.data.clientes
            }

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: cliente
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                clientesArray.map((item: any) => {
                    return cliente.push({

                        id: item.id,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        tipo_pessoa: item.tipo_pessoa,
                        cnpj_cpf: item.cnpj_cpf,
                        nome: item.nome,
                        nome_fantasia: item.nome_fantasia,
                        ie_rg: item.ie_rg,
                        ativo: item.ativo,
                        observacao: item.observacao,
                        cep: item.cep,
                        endereco: item.endereco,
                        bairro: item.bairro,
                        numero: item.numero,
                        complemento: item.complemento,
                        uf: item.uf,
                        id_cidade: item.id_cidade,
                        nome_cidade: item.nome_cidade,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dt_nascimento: item.dt_nascimento,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        description: item.nome,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: cliente
            }
        }

        return {
            error: false,
            data: cliente
        }
    },

    FilterExcluidas: async (relatorio: any): Promise<RetAPI> => {

        const resp = await Api('Cliente/Filter/Excluidas', 'get', {
            datai: relatorio.datai, 
            dataf: relatorio.dataf, 
            nome_cliente: relatorio.nome_cliente
        })
        const cliente: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: cliente
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.clientes.map((item: any) => {
                    return cliente.push({
                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        cnpj_cpf: item.cnpj_cpf,
                        nome: item.nome
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: cliente
            }

        }

        return {
            error: false,
            data: cliente,
        }

    },

    GetListCliente: async (): Promise<RetAPI> => {

        const resp = await Api('Cliente/List', 'get')
        const cliente: ClientesSearchBox[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: cliente
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.clientes.map((item: any) => {
                    return cliente.push({

                        id: item.id,
                        description: item.nome,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: cliente
            }
        }

        return {
            error: false,
            data: cliente
        }
    },

    CreateContact: async (contato: ContatoCliente): Promise<RetAPI> => {

        const resp = await Api('Cliente/Contato/Save', 'post', {
            id: contato.id,
            nome: contato.nome,
            telefone: contato.telefone,
            celular: contato.celular,
            descricao: contato.descricao,
            email: contato.email,
            id_cliente: contato.id_cliente,
        })

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            id: resp.data.contato.id,
            msg: 'Dados gravados com sucesso'
        }
    },

    BuscarContatos: async (id_cliente: number): Promise<RetAPI> => {

        const resp = await Api('Cliente/Contato/List', 'get', { id_cliente })
        let contactsList: ContatoCliente[] = []

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: contactsList
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || '',
                data: contactsList
            }
        }

        if (resp.data.contatos) {
            contactsList = resp.data.contatos.map((item: any) => {
                return {
                    id: item.id,
                    nome: item.nome,
                    telefone: item.telefone,
                    celular: item.celular,
                    email: item.email,
                    descricao: item.descricao,
                    id_cliente: item.id_cliente,

                    id_user_insert: item.id_user_insert,
                    id_user_last_update: item.id_user_last_update,
                    id_user_exclusao: item.id_user_exclusao,
                    dt_cadastro: item.dt_cadastro,
                    dt_last_update: item.dt_last_update,
                    dh_exclusao: item.dh_exclusao,
                    motivo_exclusao: item.motivo_exclusao,
                    name_user_insert: item.name_user_insert,
                    name_user_last_update: item.name_user_last_update,
                    name_user_delete: item.name_user_delete
                }
            })
        }

        return {
            error: false,
            data: contactsList
        }

    },

    DeleteContato: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Cliente/Contato/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    ClienteImportacao: async (planilha: any, mapa: any): Promise<RetAPI> => {

        const formData = new FormData()
        formData.append("mapa", JSON.stringify(mapa))
        formData.append("planilha", planilha)

        const resp = await Api('Importacao/Clientes', 'post', formData)

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }
    }

}
